import { serviceBase } from './serviceBase';
import axiosClient from './axiosClient';

export const getQuoteInformation = serviceBase({
  request: () => axiosClient.get('/aval-form/quote-information', { useAvalToken: true })
});

export const createForm = serviceBase({
  request: data => axiosClient.post('/aval-form/create-form', data, { useAvalToken: true })
});

export const sendNip = serviceBase({
  request: formId => axiosClient.post(`/aval-form/send-nip/${formId}`, {}, { useAvalToken: true })
});

export const validateNip = serviceBase({
  request: ({ formId, nip }) =>
    axiosClient.post(`/aval-form/validate-nip/${formId}`, { nip }, { useAvalToken: true })
});

export const validateCurp = serviceBase({
  request: curp => axiosClient.post('/aval-form/validate-curp', { curp }, { useAvalToken: true })
});

export const validateContactInformation = serviceBase({
  request: ({ phone, email }) =>
    axiosClient.post('/aval-form/validate-contact-information', { phone, email }, { useAvalToken: true })
});

export const submitForm = serviceBase({
  request: ({ formId, data }) =>
    axiosClient.post(`/aval-form/submit/${formId}`, data, { useAvalToken: true })
});

export const getAvalAddress = serviceBase({
  request: zipCode =>
    axiosClient.get(`/aval-form/address?zipCode=${zipCode}`, { useAvalToken: true })
});
